import { useQuery } from '@tanstack/react-query'
import type { SnapshotEntity } from 'runtimes-shared'
import getEntitiesById from '../io/api/entity/getEntitiesById'
import collectReferencedEntities, { isTextualPayload } from './collectReferencedEntities'
import { fetchResourceText, fetchText } from './resources'

const EMPTY: readonly SnapshotEntity[] = []

const useReferencedEntities = (url: string, mimeType: string | undefined): readonly SnapshotEntity[] => {
  const { data } = useQuery({
    queryKey: ['assetPluginPreviewReferences', url],
    queryFn: async () => {
      const payload = await fetchText(url)
      return payload
        ? collectReferencedEntities(payload, { getEntitiesById, readResourceText: fetchResourceText })
        : EMPTY
    },
    enabled: isTextualPayload(mimeType),
  })

  return data ?? EMPTY
}

export default useReferencedEntities
